document.addEventListener('DOMContentLoaded', () => {
    initAllAiSliders();
});

document.addEventListener('shopify:section:load', (e) => {
    initAllAiSliders(e.target);
});

function initAllAiSliders(root = document) {
    root.querySelectorAll('.ai-slider-init').forEach(slider => {
        initAiSlider(slider);
    });
}

function initAiSlider(sliderElement) {
    if (sliderElement.dataset.initialized === 'true') return;

    let options = {};
    try {
        options = JSON.parse(sliderElement.dataset.glideOptions || '{}');
    } catch (e) {
        console.error('Invalid Glide options JSON:', e);
        return;
    }

    // Ensure Glide is available
    if (typeof Glide === 'undefined') {
        const checkGlide = setInterval(() => {
            if (typeof Glide !== 'undefined') {
                clearInterval(checkGlide);
                mountAiGlide(sliderElement, options);
            }
        }, 100);
    } else {
        mountAiGlide(sliderElement, options);
    }
}

function mountAiGlide(element, options) {
    try {
        new Glide(element, options).mount();
        element.dataset.initialized = 'true';
    } catch (e) {
        console.error('Glide mount error:', e);
    }
}
